import { render, staticRenderFns } from "./upload_fileWork.vue?vue&type=template&id=477bc36a&"
import script from "./upload_fileWork.vue?vue&type=script&lang=js&"
export * from "./upload_fileWork.vue?vue&type=script&lang=js&"
import style0 from "./upload_fileWork.vue?vue&type=style&index=0&id=477bc36a&prod&lang=less&"
import style1 from "./upload_fileWork.vue?vue&type=style&index=1&id=477bc36a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports